exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qr[data-v-884a3dcc]{margin-top:1em}.checkin[data-v-884a3dcc]{min-height:300px}.text-big[data-v-884a3dcc]{margin-top:1em}.hour[data-v-884a3dcc],.text-big[data-v-884a3dcc]{font-size:3em;font-weight:700;text-transform:uppercase}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-884a3dcc","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CheckIn.vue
// module id = cnWC
// module chunks = 1